import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';

export default class HotelBenchmarkInsightDesiredCompsetController extends Controller {
  @service('benchmark-insight/competitors/desired-compset')
  declare benchmarkInsightCompetitorsDesiredCompset: Services['benchmark-insight/competitors/desired-compset'];
  @service declare intl: Services['intl'];
  @service declare router: Services['router'];
  @service declare usageAnalytics: Services['usage-analytics'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedNumberOfCompetitors() {
    return this.intl.t('benchmark_insight.count_hotels', {
      numberOfHotels:
        this.benchmarkInsightCompetitorsDesiredCompset.desiredCompetitors
          .length,
      maxNumberOfHotels:
        this.benchmarkInsightCompetitorsDesiredCompset.desiredCompset
          ?.MAX_COMPETITORS,
    });
  }

  get isSaveDisabled(): boolean {
    if (
      this.benchmarkInsightCompetitorsDesiredCompset.saveDesiredCompsetTask
        .isRunning
    ) {
      return true;
    }

    const { desiredCompset } = this.benchmarkInsightCompetitorsDesiredCompset;

    if (!desiredCompset) {
      return true;
    }

    if (!desiredCompset.isAmountOfCompetitorsValid) {
      return true;
    }

    return !desiredCompset.hasChanges;
  }

  get saveDisabledTooltipText(): string | null {
    const { desiredCompset } = this.benchmarkInsightCompetitorsDesiredCompset;

    if (!desiredCompset) {
      return null;
    }

    if (desiredCompset.competitors.length < desiredCompset.MIN_COMPETITORS) {
      return this.intl.t(
        'benchmark_insight.desired_compset.builder.footer.save_compset.tooltip',
        {
          minAmountOfCompetitors: desiredCompset.MIN_COMPETITORS,
        },
      );
    }

    return null;
  }

  @action onClickSave(): void {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.benchmarkInsightCompetitorsDesiredCompset.saveDesiredCompsetTask.perform(
      true,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.onClose,
    );

    this.usageAnalytics.track('Compset Wishlist Edited', {
      eventTrigger: 'desired-compset',
      numberOfHotels:
        this.benchmarkInsightCompetitorsDesiredCompset.desiredCompetitors
          .length,
    });
  }

  @action onClose(): void {
    // Use legacyTransitionTo to avoid the benchmark-insight model refreshing
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.router.legacyTransitionTo('hotel.benchmark-insight.index');

    this.benchmarkInsightCompetitorsDesiredCompset.discardChanges();
  }

  @action onCloseAndTrackEvent(): void {
    this.onClose();

    this.usageAnalytics.track('Compset Wishlist Cancelled', {
      eventTrigger: 'desired-compset',
    });
  }
}
